import request from '../request';
export const exportData = (params) => {
    return request({
        url: '/prod-api/dataease/datasetTree/exportData',
        method: 'post',
        body: params,
        file: true
    });
};
